namespace $ {
	/** Journals only. Shots is retained for reading legacy runs, never new writes. */
	export class $shm_hitalama_components_scenario_run extends $giper_baza_entity.with({
		Data: $giper_baza_atom_text,
		Spec: $giper_baza_atom_text,
		Shots: $giper_baza_dict_to( $giper_baza_atom_link.to( ()=> $giper_baza_file ) ),
	}) {}
}
